import styled from "styled-components";
import { PricingBg } from "../../../ui/AllImages";

const PricingWrapper = styled.section`
	&.pricingFluid{
		background-image: url(${PricingBg});
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		padding-bottom: 100px;
	}
	.priceBox{
		height: 100%;
		background-color: var(--white);
		padding: 20px 24px 20px 24px;
	}
	.priceWrapper .priceBox{
		button{
			background-color: var(--white) !important;
			border: 1px solid var(--themeColor) !important;
			border-radius: 16px !important;
			padding: 16px 16px !important;
			margin: 10px 0 10px 0;
			span{
				font-size: 20px !important;
				font-family: var(--semiBold) !important;
				color: var(--themeColor) !important;
			}
			&:hover{
				background-color: var(--secondaryColor) !important;
				border: 1px solid var(--secondaryColor) !important;
				span{
					color: var(--white) !important;
				}
			}
			body.rtl & {
				span{
					font-size: 20px !important;
					font-family: var(--arSemiBold) !important;
				}
    		}
		}
	}
	.priceWrapper > div:nth-child(2) .priceBox{

		box-shadow: 0px 36px 44px -12px rgb(64, 146, 255, .3);
		-webkit-box-shadow: 0px 36px 44px -12px rgb(64, 146, 255, .3);
		-moz-box-shadow: 0px 36px 44px -12px rgb(64, 146, 255, .3);
		button{
			background-color: var(--themeColor) !important;
			
			span{
				
				color: var(--white) !important;
			}
			&:hover{
				background-color: var(--secondaryColor) !important;
				border: 1px solid var(--secondaryColor) !important;
				span{
					color: var(--white) !important;
				}
			}
		}
	}
	span.priceSAR{
		font-size: 18px;
		font-family: var(--medium);
	}
	  .swiper-pagination-bullet {
		width: 44px;         
		height: 8px;         
		border-radius: 10px; 
		background: #ccc;    
		opacity: 1;          
		transition: background 0.3s ease;
		}

		.swiper-pagination-bullet-active {
		background: var(--themeColor); 
		}
		.swiper-horizontal{
			padding-bottom: 40px;
		}
	body.rtl &{
		span.priceSAR{
			font-size: 16px;
			font-family: var(--arMedium);
		}

	}
	

	@media (max-width: 991px){
		.priceWrapper {
			gap: 20px;
		}
		&.pricingFluid{
			padding-bottom: 70px;
		}
	}
	@media (max-width: 640px){
		.priceBox{
			padding: 20px 16px 20px 16px;
		}
		.swiper-pagination-bullet {
			width: 25px;         
			
		}
	}
	@media (max-width: 575px){
		.plan-heading{
			font-size: 24px;
		}
		.priceWrapper .priceBox{
			button{
				body.rtl & {
					span{
						font-size: 18px !important;
					}
				}
			}
		}
	}
	
	
`;

const PricingCardWrapper = styled.div`
  min-height: 500px;
  height: 100%;
  background-color: var(--white);
  box-shadow: ${({shadow}) => shadow ? shadow : "0px 19.2px 27.6px -9px #064a931a"};
  border: 1px solid ${({border}) => border ? border : "#eaedf3"};
  border-radius: 16px;
  .priceIcoCus{
	padding-bottom: 13px;
	margin-top: 16px;
  }
  body.rtl &{
	.plan-heading{
		font-size: 22px;
	}

  }
  svg {
    [stroke]{
      stroke: ${({color}) => color ? color : 'var(--themeColor2)'}!important;
    }
  }
`;

export { PricingWrapper, PricingCardWrapper };
